{
  "shared": {
    "combo": {
      "clear": "Clear {{label}}",
      "searching": "Searching…",
      "noMatches": "No matches",
      "nothing": "Nothing to choose from",
      "loadFailed": "The choices could not be loaded.",
      "unavailable": "Not available to you",
      "labelFailed": "The name could not be loaded",
      "more": "More are available. Type to narrow the list.",
      "results_zero": "No results",
      "results_one": "1 result",
      "results_two": "{{count}} results",
      "results_few": "{{count}} results",
      "results_many": "{{count}} results",
      "results_other": "{{count}} results",
      "found": {
        "suppliers_zero": "No suppliers found",
        "suppliers_one": "1 supplier found",
        "suppliers_two": "{{count}} suppliers found",
        "suppliers_few": "{{count}} suppliers found",
        "suppliers_many": "{{count}} suppliers found",
        "suppliers_other": "{{count}} suppliers found",
        "categories_zero": "No categories found",
        "categories_one": "1 category found",
        "categories_two": "{{count}} categories found",
        "categories_few": "{{count}} categories found",
        "categories_many": "{{count}} categories found",
        "categories_other": "{{count}} categories found",
        "nodes_zero": "No purchasing units found",
        "nodes_one": "1 purchasing unit found",
        "nodes_two": "{{count}} purchasing units found",
        "nodes_few": "{{count}} purchasing units found",
        "nodes_many": "{{count}} purchasing units found",
        "nodes_other": "{{count}} purchasing units found",
        "users_zero": "No users found",
        "users_one": "1 user found",
        "users_two": "{{count}} users found",
        "users_few": "{{count}} users found",
        "users_many": "{{count}} users found",
        "users_other": "{{count}} users found",
        "agreements_zero": "No agreements found",
        "agreements_one": "1 agreement found",
        "agreements_two": "{{count}} agreements found",
        "agreements_few": "{{count}} agreements found",
        "agreements_many": "{{count}} agreements found",
        "agreements_other": "{{count}} agreements found"
      },
      "remove": "Remove {{label}}",
      "overflow": "+{{n}}",
      "showAll": "Show all chosen",
      "showFewer": "Show fewer",
      "added": "{{label}} added",
      "removed": "{{label}} removed",
      "chosen": "Chosen"
    }
  }
}
